import React from "react";
import { useTranslation } from "react-i18next";
import { FileCheckIcon } from "../../../../assets/icons";
import { EmployeeCompanyPoliciesSummaryDTO } from "../../../../models/employee-company-policies-summary/employee-company-policies-summary-dto";
import IconAndTitleContainer from "../../reusable-widget-link-components/IconAndTitleContainer/IconAndTitleContainer";

const MyPoliciesLink = ({
  customSummary,
  loading,
}: {
  customSummary: EmployeeCompanyPoliciesSummaryDTO;
  loading: boolean;
}) => {
  const tRP = "components.custom_widget_links.my_policies";
  const { t } = useTranslation();
  return (
    <>
      <IconAndTitleContainer
        title={`${customSummary?.reviewedPolicies} ${t(`${tRP}.reviewed`)}`}
        Icon={FileCheckIcon}
        loading={loading}
      />
    </>
  );
};

export default MyPoliciesLink;
